import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, loadLanguage } from '@/i18n';

// A plain <select>, not a custom dropdown: eight options, needs to work on a phone,
// and the native control already handles keyboard, screen readers and the mobile
// picker sheet better than anything hand-rolled here would.
export const LanguageSwitcher: React.FC = () => {
    const { t, i18n } = useTranslation();

    return (
        <select
            className="select"
            aria-label={t('web.nav.language')}
            value={i18n.language}
            onChange={(e) => { void loadLanguage(e.target.value); }}
        >
            {LANGUAGES.map((lang) => (
                <option key={lang.code} value={lang.code}>{lang.label}</option>
            ))}
        </select>
    );
};
